import { cn } from '@/lib/utils'

/**
 * A gfbundle's apps with their versions (`gfbox 1.36`), sorted by app name. Shared by
 * the Gfbundles page, the share detail and the seed's version list.
 */
export function GfbundleApps({ apps, className }: { apps: Record<string, string>; className?: string }) {
  const entries = Object.entries(apps).sort(([a], [b]) => a.localeCompare(b))
  if (entries.length === 0) return <span className="text-xs text-muted-foreground">—</span>
  return (
    <div className={cn('flex flex-wrap gap-1', className)}>
      {entries.map(([app, version]) => (
        <span
          key={app}
          className="inline-flex items-center gap-1 rounded border bg-muted/40 px-1.5 py-0 text-[11px] font-mono text-muted-foreground"
        >
          {app}
          <span className="text-foreground">{version}</span>
        </span>
      ))}
    </div>
  )
}
